export default {
  common: {
    error: "發生錯誤",
    reload: "重新載入",
    errorNotification: "我們已收到通知，將盡快修復。如果問題持續存在，請",
    contactUs: "聯絡我們。",
    language: "語言",
    loading: "載入中...",
    loadingText: "載入中",
    save: "儲存",
    savedSuccessfully: "儲存成功",
    saving: "儲存中...",
    cancel: "取消",
    edit: "編輯",
    delete: "刪除",
    add: "新增",
    search: "搜尋",
    filter: "篩選",
    clear: "清除",
    preview: "預覽",
    default: "預設：{{value}}",
    optional: "選填",
    required: "必填",
    noData: "無資料",
  },
  // Places navigation
  places: {
    navigation: {
      locations: "地點",
      cities: "城市", 
      regions: "地區",
      countries: "國家",
      showOnMap: "在地圖上顯示",
      addLocation: "新增地點"
    },
    welcome: {
      title: "歡迎使用 Locations So Super。",
      subtitle: "從導覽中選擇一個區段開始。"
    }
  },

  // Cities section
  cities: {
    title: "城市",
    resourceSingular: "城市",
    resourcePlural: "城市",
    headings: {
      name: "名稱",
      status: "狀態",
      locations: "地點", 
      region: "地區",
      country: "國家"
    },
    breadcrumbs: {
      cities: "城市"
    }
  },

  // Countries section  
  countries: {
    title: "國家",
    resourceSingular: "國家", 
    resourcePlural: "國家",
    headings: {
      name: "名稱",
      status: "狀態",
      locations: "地點",
      cities: "城市",
      regions: "地區"
    },
    breadcrumbs: {
      countries: "國家"
    }
  },

  // Regions section
  regions: {
    title: "地區",
    resourceSingular: "地區",
    resourcePlural: "地區", 
    headings: {
      name: "名稱",
      status: "狀態",
      locations: "地點",
      cities: "城市",
      country: "國家"
    },
    breadcrumbs: {
      regions: "地區"
    }
  },

  // Map section
  map: {
    title: "地圖",
    breadcrumbs: {
      locations: "地點"
    }
  },

  // Import section
  import: {
    title: "CSV 匯入",
    breadcrumbs: {
      locations: "地點"
    },
    new: {
      title: "使用 CSV 匯入地點",
      description: "下載 CSV 範本以查看所需格式的範例",
      sampleTemplate: "CSV 範本",
      uploadAndContinue: "上傳並繼續",
      abortOnError: "發生錯誤時停止",
      abortOnErrorHelp: "如果有錯誤，匯入將停止，顯示錯誤，且不會匯入任何地點。",
      needHelp: "需要地點匯入協助？"
    },
    show: {
      title: "CSV 匯入",
      youCanLeavePage: "您可以離開此頁面",
      backgroundMessage: "您的匯入將在背景中繼續執行",
      importProgress: "匯入進度",
      imported: "已匯入",
      suffix: "地點",
      importLog: "匯入記錄",
      cancelImport: "取消匯入",
      cancelConfirmation: {
        title: "取消匯入",
        message: "您確定要取消此匯入作業嗎？此操作無法復原。",
        note: "注意：對於正在進行的作業，作業需要完成並將立即刪除。",
        yesCancel: "是，取消匯入",
        noContinue: "否，繼續匯入"
      },
      report: "報告",
      failedLocations: "失敗的地點",
      uploadAnother: "上傳另一個 CSV",
      backToLocations: "返回地點",
      importSucceeded: "匯入成功",
      importFailed: "匯入失敗"
    },
    messages: {
      uploadSuccess: "CSV 上傳成功",
      uploadError: "無法上傳 CSV",
      pending: "匯入尚未開始",
      inProgress: "匯入中",
      completed: "匯入完成",
      invalidHeader: "以下欄位為必填",
      invalidCsvFile: "無效的 CSV 檔案",
      aborted: "匯入已中止",
      failed: "匯入失敗",
      cancelled: "匯入已取消"
    },
    errors: {
      csvTooLarge: "CSV 檔案過大",
      languageNotEnabled: "語言 '{{language}}' 未在此商店啟用。請先在設定 > 語言中啟用。",
      fieldNotTranslatable: "欄位 '{{field}}' 無法翻譯。可翻譯的欄位：{{fields}}",
      locationError: "具有 slug 的地點：{{slug}} - {{error}}",
      planLimit: "您已達到地點的計劃限制"
    }
  },
  // Location form
  location: {
    index: {
      title: "地點",
      addLocation: "新增地點",
      import: "匯入",
      noPrioritySet: "未設定優先級",
      published: "已發布",
      draft: "草稿",
      resourceSingular: "地點",
      resourcePlural: "地點",
      headings: {
        name: "名稱",
        status: "狀態", 
        city: "城市",
        region: "地區",
        country: "國家",
        priority: "優先級"
      }
    },
    form: {
      title: "新增地點",
      editTitle: "編輯地點",
      basicInformation: "基本資訊",
      name: "名稱",
      namePlaceholder: "例如：Brians Bricks",
      nameHelpDefault: "預設：{{defaultName}}",
      details: "詳情",
      description: "描述",
      descriptionPlaceholder: "告訴客戶此地點的特殊之處",
      address: "地址",
      addressPlaceholder: "123 主要街道，城市，國家",
      addressLine1: "地址第一行",
      addressLine2: "地址第二行",
      postalZipCode: "郵遞區號 / ZIP 碼",
      city: "城市",
      stateProvinceRegion: "州 / 省 / 地區",
      country: "國家",
      phone: "電話",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "電子郵件", 
      emailPlaceholder: "store@example.com",
      website: "網站",
      websitePlaceholder: "https://www.example.com",
      image: "圖片",
      imagePlaceholder: "輸入圖片 URL",
      status: "狀態",
      statusActive: "啟用",
      statusInactive: "停用",
      statusDraft: "草稿",
      priority: "優先級",
      priorityHelpText: "優先級較高的地點會在搜尋結果中優先顯示",
      findOnMapButton: "在地圖上尋找"
    },
    validation: {
      addressNotFound: "找不到地址",
      createSuccess: "地點建立成功", 
      updateSuccess: "地點更新成功",
      checkFields: "請檢查您的欄位",
      findOnMap: "儲存前請在地圖上找到您的地點"
    },
    errors: {
      loading: "載入地點時發生錯誤"
    },
    actions: {
      save: "儲存地點",
      delete: "刪除地點",
      preview: "預覽"
    },
    customFields: {
      title: "自訂欄位",
      noCustomFields: "未設定自訂欄位",
      configureFields: "設定欄位",
      emptyState: "您尚未設定任何自訂欄位。自訂欄位可讓您新增符合業務需求的額外資訊。"
    },
    openingHours: {
      title: "營業時間",
      checkboxLabel: "此地點有營業和打烊時間",
      statusOpen: "營業中",
      statusOpen24h: "24 小時營業",
      statusClosed: "休息中",
      openingTimeLabel: "營業時間",
      closingTimeLabel: "打烊時間",
      days: {
        monday: "星期一",
        tuesday: "星期二", 
        wednesday: "星期三",
        thursday: "星期四",
        friday: "星期五",
        saturday: "星期六",
        sunday: "星期日"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "最近新增",
        recentlyModified: "最近修改"
      },
      filters: {
        status: "狀態",
        taggedWith: "標籤為",
        locationStatus: "地點狀態",
        noTagsToShow: "沒有可顯示的標籤",
        searchPlaceholder: "搜尋"
      },
      bulkActions: {
        setPublished: "設為已發布",
        setUnpublished: "設為未發布", 
        setPriority: "設定優先級",
        deleteLocations: "刪除地點",
        exportCSV: "匯出為 CSV"
      },
      appliedFilters: {
        statusIs: "狀態為 {{status}}",
        taggedWith: "標籤為 {{tag}}",
        nameIncludes: "名稱包含 {{search}}"
      },
      modals: {
        deleteTitle: "刪除地點",
        deleteMessage: "您確定要刪除 {{count}} 個項目嗎？",
        deleteMessageAll: "您確定要刪除所有地點嗎？",
        prioritiseTitle: "設定 {{count}} 個地點的優先級",
        prioritiseTitleAll: "設定所有地點的優先級",
        delete: "刪除",
        cancel: "取消"
      },
      emptyState: {
        noResultsHeading: "找不到任何 {{resourcePlural}}",
        noResultsText: "嘗試變更篩選條件或搜尋詞",
        noDataHeading: "新增地點以填入 {{resourcePlural}}",
        addLocation: "新增地點",
        importFromCSV: "從 CSV 匯入"
      },
      pagination: {
        label: "第 {{page}} 頁，共 {{pages}} 頁"
      },
      messages: {
        updatedSuccessfully: "更新成功",
        deletedSuccessfully: "刪除成功", 
        exportedSuccessfully: "匯出成功",
        error: "發生錯誤"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "頁面內容",
    editTemplate: "編輯 SEO 範本", 
    pageTitle: "標題",
    pageDescription: "描述",
    metaTitle: "標題",
    metaDescription: "描述",
    urlHandle: "URL 代碼",
    searchEnginePreview: "搜尋引擎列表預覽",
    editMeta: "編輯 Meta",
    previewMeta: "預覽 Meta",
    loading: "載入中...",
    editingLocaleHelp: "編輯 {{locale}} 內容。"
  },

  // SEO Templates section
  seoTemplates: {
    title: "SEO 範本",
    breadcrumbs: {
      seoTemplates: "SEO 範本"
    },
    template: {
      title: "{{templateName}} 範本 - {{locale}}",
      discardChanges: "捨棄變更"
    },
    form: {
      pageContent: "頁面內容",
      searchEnginePreview: "搜尋引擎列表預覽",
      title: "標題",
      description: "描述",
      pageTitle: "頁面標題",
      metaDescription: "Meta 描述",
      editingLocaleHelp: "編輯 {{locale}} 翻譯。空白欄位將顯示 {{defaultLocale}} 內容。",
      defaultValue: "預設：{{value}}"
    },
    language: {
      label: "語言",
      defaultHelp: "這是您的預設語言",
      editingHelp: "編輯 {{locale}} 翻譯。空白欄位將顯示 {{defaultLocale}} 內容。"
    },
    banner: {
      multipleLanguagesDisabled: "多語言未啟用",
      enableInSettings: "在設定中啟用",
      multipleLanguagesInfo: "要管理多語言的 SEO 範本，請在語言設定中啟用國際化。目前僅顯示 {{locale}} 範本。"
    },
    badges: {
      errors: "錯誤！",
      unsaved: "未儲存"
    },
    messages: {
      saveSuccess: "SEO 範本儲存成功",
      saveError: "無法儲存範本",
      error: "錯誤..."
    }
  },
  // Area form
  area: {
    form: {
      basicInformation: "基本資訊",
      name: "名稱",
      save: "儲存",
      saving: "儲存中...",
      cancel: "取消",
      yourLocationsIn: "您在 {{name}} 的地點",
      tableHeadings: {
        name: "名稱",
        status: "狀態",
        city: "城市",
        region: "地區",
        country: "國家"
      },
      resourceName: {
        singular: "{{name}} 地點",
        plural: "{{name}} 中的地點"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "地圖",
      tags: "標籤",
      customFields: "自訂欄位",
      languages: "語言",
      plan: "計劃",
      addTag: "新增標籤",
      addField: "新增欄位"
    },
    planBadges: {
      trial: "！",
      endsSoon: "即將結束"
    },
    common: {
      loading: "載入中...",
      error: "錯誤...",
      breadcrumbs: {
        settings: "設定"
      },
      skeleton: {
        customFields: "自訂欄位",
        addField: "新增欄位",
        name: "名稱",
        contentType: "內容類型",
        usedIn: "使用於",
        field: "欄位",
        fields: "欄位"
      },
      messages: {
        savedSuccessfully: "{{setting}} 設定儲存成功",
        couldntSave: "無法儲存 {{setting}} 設定"
      }
    },
    map: {
      title: "地圖",
      messages: {
        savedSuccessfully: "地圖設定儲存成功",
        couldntSave: "無法儲存設定"
      },
      mapboxToken: {
        title: "Mapbox 權杖",
        description: "輸入您的 Mapbox 權杖以為您的商店定位器提供動力",
        label: "Mapbox 權杖",
        placeholder: "在此輸入權杖以繼續使用您的地圖。",
        placeholderManaged: "在此輸入權杖以在您用完免費地圖載入次數後繼續使用您的地圖。",
        helpText: "按照我們的指示建立 Mapbox 金鑰，然後將您的金鑰貼上上方。如果您遇到任何問題，請聯絡我們尋求協助。",
        linkInstructions: "建立 Mapbox 金鑰的指示",
        linkSupport: "聯絡我們尋求協助"
      },
      managedToken: {
        title: "地圖載入次數",
        description: "您有最多 {{max}} 次免費地圖載入次數，之後您需要建立自己的權杖。"
      },
      appearance: {
        title: "外觀",
        description: "變更您地圖的視覺效果"
      },
      mapStyle: {
        title: "地圖樣式",
        options: {
          streets: "街道",
          outdoors: "戶外", 
          light: "淺色",
          dark: "深色",
          satellite: "衛星",
          satelliteStreets: "衛星街道",
          navigationDay: "日間導航",
          navigationNight: "夜間導航"
        }
      },
      searchBehaviour: {
        title: "搜尋行為",
        description: "控制訪客如何在地圖上找到地點。",
        geolocateLabel: "自動估計訪客位置並顯示附近的商店",
        geolocateHelp: "如果地理定位成功，地圖將移動到訪客附近。如果找不到估計位置，地圖將保持在起始位置。",
        filterBehaviour: {
          title: "篩選行為",
          all: {
            label: "所有標籤",
            help: "地點必須具有所有選定的標籤才能顯示在篩選中"
          },
          any: {
            label: "任何標籤", 
            help: "地點可以具有任何選定的標籤才能顯示在篩選中"
          }
        },
        keepSearchInView: {
          label: "保持搜尋標記在視圖中",
          help: "當搜尋結果出現時，地圖將縮小以顯示所有匹配的地點"
        },
        distanceUnits: {
          title: "距離單位",
          km: "公里",
          miles: "英里"
        },
        maxResults: {
          label: "最大結果數",
          help: "限制搜尋結果中顯示的地點數量",
          options: {
            results30: "30 個結果"
          }
        },
        maxDistance: {
          label: "最大距離", 
          help: "僅顯示搜尋點此距離內的地點",
          options: {
            unlimited: "無限制"
          }
        },
        showLocationNames: {
          label: "在建議中顯示地點名稱",
          help: "在搜尋建議中顯示地點名稱"
        },
        sortByPriority: {
          label: "按優先級而非距離排序",
          help: "強烈建議如果勾選此方塊，請設定最大距離（非無限制）。否則您的客戶將看到遠距離但優先級高的地點列在合理距離內的地點之上。"
        }
      },
      searchResults: {
        title: "搜尋結果",
        description: "控制地點如何在地圖上返回。",
        locationsLabel: "搜尋結果文字",
        locationsHelp: "顯示在搜尋結果上方的文字（例如，'顯示 5 個地點'）",
        prefixLabel: "搜尋結果前綴", 
        prefixHelp: "顯示在結果數量之前的文字"
      },
      popups: {
        title: "彈出視窗",
        showPopups: {
          label: "顯示彈出視窗",
          help: "當訪客點擊地圖標記時顯示地點詳細資訊"
        }
      },
      whitelabel: {
        title: "白標",
        hideLabel: "隱藏由...提供文字",
        hideHelp: "從您的商店定位器中移除我們的品牌"
      }
    },
    languages: {
      title: "語言",
      error: "錯誤...",
      messages: {
        savedSuccessfully: "語言設定儲存成功",
        couldntSave: "無法儲存語言設定"
      },
      banner: {
        upgradeTitle: "多語言支援需要升級計劃",
        upgradeAction: "升級到 Superest",
        upgradeMessage: "您仍然可以變更預設語言，但啟用多語言需要升級。",
        disabledMessage: "您目前計劃中已停用多語言設定"
      },
      defaultLanguage: {
        title: "預設語言", 
        description: "選擇您內容將顯示的主要語言。",
        label: "預設語言",
        help: "當沒有請求特定語言時將使用此語言"
      },
      internationalization: {
        title: "國際化",
        description: "啟用多語言。接觸更多客戶並提升您的 SEO。",
        enableLabel: "啟用多語言",
        enableHelp: "允許客戶以不同語言查看您的商店定位器"
      },
      supportedLanguages: {
        title: "其他支援的語言",
        description: "選擇您想要支援的語言。啟用語言後，您將看到翻譯整個應用程式的選項。對於支援的語言，將自動建立通用 SEO 範本和主題變數範本。",
        defaultLocaleNote: "這是您的預設語言且無法停用",
        shopifyEnabled: {
          label: "此語言在我的 Shopify 商店中已啟用",
          importantNote: "重要：",
          description: "如果此語言未在您的 Shopify 商店中啟用和發布，請取消勾選上方的方塊。您應該先在 Shopify 商店中啟用語言，方法是前往 Shopify 控制台中的設定 > 語言（如果尚未完成）"
        },
        urlFormats: {
          cleanUrls: "乾淨 URL：",
          betterSeo: "更好的 SEO 和使用者體驗",
          queryUrls: "查詢參數 URL：",
          considerEnabling: "考慮在 Shopify 中啟用以獲得更好的 URL"
        },
        preview: {
          button: "預覽",
          tooltip: "{{language}} 商店定位器預覽"
        },
        tooltips: {
          noTemplates: "此語言沒有預設 SEO 範本。您可以輕鬆建立自訂翻譯"
        }
      }
    },
    tags: {
      title: "標籤",
      addTag: "新增標籤",
      error: "錯誤",
      messages: {
        deletedSuccessfully: "標籤刪除成功",
        couldntDelete: "無法刪除標籤",
        savedSuccessfully: "標籤儲存成功",
        couldntSave: "請檢查您的欄位",
        tagDeleted: "標籤刪除成功"
      },
      resourceName: {
        singular: "標籤",
        plural: "標籤"
      },
      filters: {
        anyGroup: "任何群組",
        inGroup: "在群組中",
        tagGroup: "標籤群組"
      },
      appliedFilters: {
        inGroup: "在 {{group}} 群組中",
        nameContains: "標籤名稱包含搜尋 {{query}}"
      },
      bulkActions: {
        deleteTag: "刪除標籤",
        deleteTags: "刪除標籤"
      },
      form: {
        language: "語言",
        title: "標題",
        description: "描述",
        group: "群組",
        groupPlaceholder: "選擇群組",
        addGroup: "新增",
        editingTranslations: "編輯 {{language}} 翻譯。空白欄位將顯示 {{defaultLanguage}} 內容。",
        defaultValue: "預設：{{value}}",
        image: "圖片",
        imageUrl: "圖片 URL"
      },
      actions: {
        save: "儲存",
        deleteTag: "刪除標籤"
      },
      new: {
        title: "新增標籤",
        messages: {
          createSuccess: "標籤建立成功",
          checkFields: "請檢查您的欄位"
        },
        actions: {
          createTag: "建立標籤"
        }
      }
    },
    customFields: {
      title: "自訂欄位",
      addField: "新增欄位",
      error: "錯誤",
      resourceName: {
        singular: "欄位",
        plural: "欄位"
      },
      headings: {
        name: "名稱",
        contentType: "內容類型",
        usedIn: "使用於"
      },
      emptyState: {
        heading: "建立和管理您的自訂欄位",
        createAction: "建立欄位",
        description: "使用自訂欄位滿足您業務的特定需求。這些欄位可以是社群媒體連結或商店經理姓名和電子郵件"
      },
      pluralization: {
        location: "地點",
        locations: "地點"
      },
      form: {
        name: "名稱",
        contentType: "內容類型",
        key: "金鑰",
        keyPrefix: "location.fields.",
        keyHelp: "在您的範本中使用此金鑰存取 {{name}} 地點的內容",
        translations: {
          title: "翻譯",
          showTranslations: "顯示翻譯",
          hideTranslations: "隱藏翻譯",
          description: "翻譯是可選的。如果欄位為空，將顯示 {{language}} 欄位名稱。",
          nameTranslation: "名稱 ({{language}})",
          defaultValue: "預設：{{value}}"
        }
      },
      messages: {
        savedSuccessfully: "欄位儲存成功",
        couldntSave: "無法儲存欄位",
        deletedSuccessfully: "欄位刪除成功",
        couldntDelete: "無法刪除欄位"
      },
      actions: {
        delete: "刪除"
      },
      new: {
        title: "新增欄位",
        messages: {
          savedSuccessfully: "欄位儲存成功",
          couldntSave: "無法儲存欄位"
        }
      },
      contentTypes: {
        text: "文字",
        textArea: "文字區域",
        email: "電子郵件",
        number: "數字",
        phoneNumber: "電話號碼",
        time: "時間",
        url: "URL"
      }
    },
    plan: {
      title: "計劃",
      error: "錯誤",
      changePlan: "變更計劃",
      usdPerMonth: "美元 / 月",
      sections: {
        yourPlanIncludes: "您的計劃包括",
        nextBillingDate: "下次帳單日期",
        trial: "試用"
      },
      banners: {
        planUpdated: "您的計劃已更新",
        thankYouUpgrading: "感謝您升級！",
        letUsKnow: "告訴我們",
        improvementText: "如果有任何我們可以改進的地方",
        trialCancellation: {
          title: "試用取消通知",
          message: "一旦您升級到付費計劃，您的14天免費試用將被取消。"
        }
      },
      locations: {
        upTo: "最多",
        locations: "地點",
        unlimited: "無限制地點",
        used: "已使用",
        ofUsed: "已使用 {{used}} / {{max}}"
      },
      trial: {
        daysLeft: "剩餘 {{days}} 天",
        daysUsed: "已使用 {{used}} / {{total}} 天",
        selectPlan: "選擇計劃",
        currentPlan: "目前計劃",
        trialBadge: "試用",
        currentBadge: "目前",
        yourTrialJustStarted: "您的試用剛開始",
        trialEndsAfterToday: "您的試用今天後結束",
        trialEndsTomorrow: "您的試用明天結束",
        daysLeftInTrial: "您的試用中剩餘 {{days}} 天",
        continueAddingLocations: "在 {{date}} 後選擇計劃以繼續新增地點",
        selectPlanToday: "請今天選擇計劃以繼續新增地點"
      },
      footer: {
        description: "管理或變更您的 Locations So Super 計劃。查看我們的服務條款",
        termsOfService: "服務條款",
        and: "和",
        privacyPolicy: "隱私政策"
      },
      features: {
        analytics: {
          title: "分析",
          description: "了解客戶如何使用您的地點以及他們在搜尋什麼"
        },
        internationalization: {
          title: "多語言支援",
          description: "透過啟用多語言來提升您的 SEO 並在目標市場中開展業務"
        },
        customThemes: {
          editLiquid: {
            title: "編輯 Liquid 主題範本",
            description: "透過 Liquid 主題存取以您想要的方式顯示地點資料"
          },
          editStructuredData: {
            title: "編輯業務結構化資料",
            description: "透過編輯結構化資料來改變 Google 如何理解您的所有頁面"
          }
        }
      },
      edit: {
        title: "變更計劃",
        allPlansInclude: "所有計劃包括",
        needingMoreLocations: "需要更多地點？",
        footerQuestion: "開始前有問題嗎？",
        sendMessage: "發送訊息給我們",
        allFeatures: {
          seoDirectory: {
            title: "SEO 目錄和登陸頁面",
            description: "為您所有的地點、城市和地區建立 SEO 目錄"
          },
          mapPage: {
            title: "具有搜尋和篩選的地圖頁面",
            description: "在 Mapbox 支援的地圖上搜尋和篩選您所有的地點"
          },
          tags: {
            title: "標籤",
            description: "建立具有圖片和描述的標籤並分組"
          },
          openingHours: {
            title: "營業時間",
            description: "為您的地點設定和顯示營業時間"
          },
          mapStyles: {
            title: "地圖樣式",
            description: "使用自訂樣式變更您地圖的外觀"
          },
          customFields: {
            title: "自訂欄位",
            description: "從社群媒體連結到商店經理姓名，新增您想要的任何欄位"
          },
          csvUpload: {
            title: "使用 CSV 上傳和匯出",
            description: "使用批次覆寫上傳和編輯地點"
          },
          richSnippets: {
            title: "Google 的豐富摘要",
            description: "透過本地業務結構化資料幫助 Google 理解您的所有頁面"
          },
          directionsAndCalls: {
            title: "路線和通話",
            description: "客戶可以輕鬆為地點取得路線和撥打電話"
          },
          languageSupport: {
            title: "語言支援",
            description: "將預設語言變更為非英語的其他語言。提供的範本附帶 32 種主要語言的現成翻譯，便於設定"
          }
        }
      },
      planCard: {
        bestToCustomize: "最適合自訂",
        currentPlan: "目前計劃",
        chooseThisPlan: "選擇此計劃",
        locationsSection: "地點",
        featuresSection: "功能",
        upTo: "最多",
        locations: "地點",
        tooltipTooManyLocations: "您有太多地點或已啟用的語言，超出此計劃的限制"
      },
      confirmation: {
        error: "計劃確認錯誤"
      }
    }
  },

  // Themes section
  themes: {
    title: "主題",
    currentTheme: {
      title: "目前主題",
      description: "這是客戶存取您的地點應用程式時看到的主題"
    },
    themeLibrary: {
      title: "主題範本",
      description: "管理您地點的主題範本。新增和發布範本以變更您線上地點的外觀"
    },
    skeleton: {
      currentThemeDescription: "這是客戶存取您的地點應用程式時看到的主題"
    },
    modal: {
      overrideTitle: "存取目前主題？",
      override: "存取",
      cancel: "取消",
      undoWarning: "此操作無法復原"
    },
    messages: {
      publishSuccess: "範本發布成功",
      publishError: "無法發布範本",
      error: "發生錯誤"
    },
    emptyStates: {
      settings: {
        heading: "此主題沒有設定",
        description: "在範本編輯器中建立設定",
        createSettings: "建立設定",
        upgradePlan: "升級計劃",
        upgradeRequired: "需要升級計劃才能建立設定"
      },
      language: {
        heading: "此主題沒有語言範本",
        description: "在範本編輯器中建立語言範本",
        createLanguageTerms: "建立語言範本",
        upgradePlan: "升級計劃",
        upgradeRequired: "需要升級計劃才能建立語言範本"
      }
    },
    templates: {
      categories: {
        templates: "範本",
        schemas: "結構描述",
        styles: "樣式",
        liquidReference: "Liquid 參考"
      },
      items: {
        landing: "登陸頁面",
        directory: "目錄",
        country: "國家",
        region: "地區",
        city: "城市",
        location: "地點",
        language: "語言",
        settings: "設定",
        stylesheet: "樣式表"
      },
      errors: {
        errorsInTemplate: "範本中的錯誤",
        error: "錯誤"
      },
      badges: {
        errors: "錯誤！",
        unsaved: "未儲存"
      },
      actions: {
        viewTheme: "查看主題",
        discard: "捨棄",
        save: "儲存"
      }
    },
    language: {
      messages: {
        saveSuccess: "主題範本翻譯儲存成功",
        saveError: "無法儲存範本"
      },
      form: {
        language: "語言",
        defaultLanguageHelp: "這是您的預設語言",
        translationHelp: "編輯 {{selectedLocale}} 翻譯。空白欄位將顯示 {{defaultLocale}}（您的預設語言）內容"
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "多語言未啟用",
          action: "在設定中啟用",
          description: "要管理翻譯，請在語言設定中啟用國際化。目前僅顯示 {{locale}} 翻譯範本"
        },
        translating: {
          title: "從 {{from}} 翻譯到 {{to}}",
          description: "空白欄位將自動顯示 {{defaultLocale}} 使用者內容，但您只需要翻譯在 {{selectedLocale}} 中需要不同內容的欄位"
        }
      },
      accessLanguageTerms: "使用 {{code}} 存取 {{category}} 語言範本",
      fields: {
        // Common language fields - add specific ones as needed
        title: "標題",
        description: "描述",
        heading: "標題",
        subheading: "副標題",
        button_text: "按鈕文字",
        link_text: "連結文字",
        placeholder: "預留位置",
        label: "標籤",
        help_text: "說明文字",
        error_message: "錯誤訊息",
        success_message: "成功訊息",

        // Opening hours
        Monday: "星期一",
        Tuesday: "星期二",
        Wednesday: "星期三",
        Thursday: "星期四",
        Friday: "星期五",
        Saturday: "星期六",
        Sunday: "星期日",
        opening_hours_format: "營業時間格式",
        closes_at_format: "打烊時間格式",
        opens_at_format: "營業時間格式",
        opens_on: "營業日",
        open_24h: "24 小時營業",
        open: "營業中",
        closed: "休息中",
        closes_at: "打烊時間",
        opens_at: "營業時間",

        // Map
        search_map: "搜尋地圖",
        search_area: "搜尋此區域",
        view_map: "地圖",
        view_list: "列表",
        open_filters: "篩選",
        stores_near_you: "您附近的商店",
        header: "尋找商店！",
        search_placeholder: "輸入郵遞區號或地址...",
        no_listings: "我們搜尋了全世界，但找不到您搜尋的地點。嘗試變更篩選或搜尋位置",

        // Directory
        view_directory: "商店目錄",

        // Location
        get_directions: "取得路線",
        call: "撥打電話",
        view_website: "網站",
        email: "電子郵件",
        opening_hours_header: "營業時間",
        description_header: "資訊",
        phone_number_header: "電話號碼",
        address_header: "地址",
        tag_groups_to_display: "要顯示的標籤群組"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "一般",
        navigation: "導覽",
        forms: "表單",
        buttons: "按鈕",
        messages: "訊息",
        errors: "錯誤",
        opening_hours: "營業時間",
        map: "地圖",
        directory: "目錄",
        location: "地點"
      }
    },
    settings: {
      messages: {
        saveSuccess: "主題儲存成功",
        saveError: "無法儲存主題"
      },
      accessSettings: "使用 {{code}} 存取 {{category}} 設定",
      fields: {
        // Colors
        color_text: "文字顏色",
        color_text_heading: "標題文字顏色",
        color_background: "背景顏色",
        color_accent: "強調色",
        color_text_positive: "正面文字顏色",
        color_text_negative: "負面文字顏色",
        dark_theme: "深色主題",
        color_marker: "標記顏色",
        color_search_marker: "搜尋標記顏色",

        // Typography
        base_font_size: "基本字體大小",

        // Buttons
        border_radius: "邊框半徑",

        // Images
        aspect_ratio: "長寬比",
        fit: "適合",

        // Spacing
        page_width: "頁面寬度",
        page_width_small: "小頁面寬度",
        gutter_desktop: "桌面間距",
        gutter_mobile: "行動間距",
        desktop_vertical_spacing: "桌面垂直間距",
        mobile_vertical_spacing: "行動垂直間距",

        // Breakpoints
        breakpoint_xs: "XS 斷點",
        breakpoint_sm: "SM 斷點",
        breakpoint_md: "MD 斷點",

        // Map
        search_on_move: "移動時搜尋",
        scroll_to_zoom: "滾動縮放",

        // Landing page
        sidebar_width: "側邊欄寬度",
        sidebar_min_height: "側邊欄最小高度",
        marker_image_src: "標記圖片來源",
        show_filter_descriptions: "顯示篩選描述",

        // Location page
        tag_groups_to_display: "要顯示的標籤群組",
        tag_groups_to_display_as_icons: "要顯示為圖示的標籤群組",
        show_related_locations: "顯示相關地點",

        // Locations
        hide_regions: "隱藏地區"
      },
      categories: {
        colors: "顏色",
        typography: "字體",
        buttons: "按鈕",
        images: "圖片",
        spacing: "間距",
        breakpoints: "斷點",
        map: "地圖",
        landing_page: "登陸頁面",
        location_page: "地點頁面",
        locations: "地點"
      }
    },
    navigation: {
      sublimeTheme: "Sublime 主題",
      settings: "設定",
      language: "語言",
      templates: "範本",
      changeTheme: "變更主題",
      viewDirectory: "查看目錄",
      viewLandingPage: "查看登陸頁面"
    },
    card: {
      lastUpdated: "最後更新",
      view: "查看",
      customize: "自訂",
      publish: "發布",
      actions: "動作"
    }
  },

  // Analytics section
  analytics: {
    title: "分析",
    timePeriods: {
      last7days: "過去 7 天",
      last30days: "過去 30 天"
    },
    comparison: {
      compareToPrevious: "與前一個時期比較",
      stopComparing: "停止與前一個時期比較"
    },
    sections: {
      searchLocations: "搜尋地點"
    },
    cards: {
      sessions: "工作階段",
      topSearches: "熱門搜尋",
      topLandingPageType: "熱門登陸頁面類型",
      topPageViewsBySession: "每個工作階段最常查看的頁面",
      topLocations: "熱門地點",
      topReferrers: "熱門推薦來源",
      searches: "搜尋",
      topLandingPagesBySession: "每個工作階段最常查看的登陸頁面"
    },
    chartLabels: {
      desktop: "桌面"
    }
  },

}; 